import React, { useEffect, useState } from 'react';
import {
    Table, Button, Header, Modal
} from 'semantic-ui-react';
import Swal from '#/swal';
import { connect } from 'react-redux';
import { actions } from './sagaSlice';
import Form from './Form';

const LawyerList = props => {
    const { readAll, lawyers } = props;

    const [modalOpen, setModalOpen] = useState(false);
    const [initialValues, setInitialValues] = useState(null);

    const onSubmit = async values => {

        initialValues ? await props.update(values) : await props.create(values);
        setModalOpen(false);
    };


    const handleDelete = async ({ name, id }) => {
        const { value } = await Swal.fire.warning({ text: `This will delete ${name}.` });

        if (value) props.delete(id);
    };

    useEffect(readAll, [readAll]);

    return (
        <div style={styles.root}>
            <div style={styles.header}>
                <div>
                    <Header
                        as='h2'
                        content='Lawyers'
                        color='grey'
                    />
                </div>

                <div>
                    <Button
                        compact
                        primary
                        icon='add'
                        content='New Lawyer'
                        onClick={() => {
                            setInitialValues(null);
                            setModalOpen(true);
                        }}
                    />
                </div>

            </div>
            <Table compact singleLine columns={5} celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell content='Name'/>
                        <Table.HeaderCell content='Address'/>
                        <Table.HeaderCell content='Phone #'/>
                        <Table.HeaderCell content='Bar #'/>
                        <Table.HeaderCell textAlign='center' content='Actions'/>
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {
                        lawyers
                    && lawyers.map((lawyer, i) => (
                        <Table.Row key={i}>
                            <Table.Cell content={lawyer.name}/>
                            <Table.Cell content={lawyer.address}/>
                            <Table.Cell content={lawyer.phone_number}/>
                            <Table.Cell content={lawyer.bar_number}/>
                            <Table.Cell textAlign='center'>

                                <Button
                                    compact
                                    size='small'
                                    icon='edit'
                                    onClick={() => {
                                        setInitialValues(lawyer);
                                        setModalOpen(true);
                                    }}
                                    content='Edit'
                                />
                                <Button
                                    compact
                                    size='small'
                                    color='red'
                                    icon='delete'
                                    onClick={() => handleDelete(lawyer)}
                                    content='Delete'
                                />

                            </Table.Cell>
                        </Table.Row>
                    ))
                    }
                </Table.Body>

            </Table>
            <Modal
                open={modalOpen}
                size='tiny'>
                <Modal.Content>
                    <Form onSubmit={onSubmit} setModalOpen={setModalOpen} initialValues={initialValues}/>
                </Modal.Content>
            </Modal>
        </div>
    );
};

const styles = {
    root: { margin: '10px' },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        margin: '10px',
        alignItems: 'center',
        paddingTop: '20px'
    }
};

const mapStateToProps = state => ({ lawyers: Object.values(state.lawyers.data) });

export default connect(mapStateToProps, actions)(LawyerList);
